import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

/*
 ** @description Prepare data for api
 ** @param props Object route, reference_number, carrier, departure_time, arrival_time, active
 ** @return data object
 */
const handlePrepareData = ({
  name, travel_mode, route_type, departure_location, arrival_location, active
}) => ({
  name,
  travel_mode,
  route_type: route_type.key,
  type: route_type.key,
  departure_location_id: departure_location.key,
  arrival_location_id: arrival_location.key,
  active
});

const Routes = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminTravel()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.travelRoute,
      list: REDUCER_KEY.travelRoutes
    }}
    config={config}
    permissions={permissions}
    onPrepareData={handlePrepareData}
  />
);

Routes.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Routes;
